export default __webpack_public_path__ + "static/media/blur 2.d72cd12e.jpg";